import { useState } from 'react';
import PublicPageShell, { SectionHeading } from '@/components/PublicPageShell';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Mail, Globe, User as UserIcon, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';

const CONTACTS = [
  { icon: Globe, label: 'Platform', value: 'www.futurexv.co.za', href: 'https://www.futurexv.co.za' },
  { icon: Mail,  label: 'All enquiries', value: 'info@futurexv.co.za', href: 'mailto:info@futurexv.co.za' },
];

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = encodeURIComponent(`From: ${name} <${email}>\n\n${message}`);
    const sub = encodeURIComponent(subject || 'Enquiry from FutureXV website');
    window.location.href = `mailto:info@futurexv.co.za?subject=${sub}&body=${body}`;
    toast.success('Opening your email client…');
  };

  return (
    <PublicPageShell
      eyebrow="CONTACT"
      title="Talk to the FutureXV team"
      intro="Questions, partnership enquiries, voucher requests or platform support — we'd love to hear from you."
      dataTestId="contact-page"
    >
      <div className="grid md:grid-cols-2 gap-10">
        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
          <div>
            <label className="text-zinc-300 text-sm flex items-center gap-2 mb-1.5"><UserIcon className="w-3.5 h-3.5" /> Your name</label>
            <Input value={name} onChange={(e) => setName(e.target.value)} required className="bg-[#0a0a0a] border-zinc-800 text-white h-12" data-testid="contact-name" />
          </div>
          <div>
            <label className="text-zinc-300 text-sm flex items-center gap-2 mb-1.5"><Mail className="w-3.5 h-3.5" /> Your email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-[#0a0a0a] border-zinc-800 text-white h-12" data-testid="contact-email" />
          </div>
          <div>
            <label className="text-zinc-300 text-sm mb-1.5 block">Subject</label>
            <Input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="What's this about?" className="bg-[#0a0a0a] border-zinc-800 text-white h-12" data-testid="contact-subject" />
          </div>
          <div>
            <label className="text-zinc-300 text-sm flex items-center gap-2 mb-1.5"><MessageSquare className="w-3.5 h-3.5" /> Message</label>
            <Textarea value={message} onChange={(e) => setMessage(e.target.value)} required rows={6} className="bg-[#0a0a0a] border-zinc-800 text-white" data-testid="contact-message" />
          </div>
          <Button type="submit" className="bg-[#A3FF00] hover:bg-[#88dd00] text-black font-bold px-8 py-6 w-full" data-testid="contact-submit">
            Send message
          </Button>
        </form>

        {/* Direct contacts */}
        <div>
          <SectionHeading>Direct lines</SectionHeading>
          <ul className="space-y-3" data-testid="contact-direct-list">
            {CONTACTS.map(({ icon: Icon, label, value, href }) => (
              <li key={label} className="bg-[#0a0a0a] border border-zinc-800 rounded-lg p-4 hover:border-[#A3FF00]/30 transition-colors">
                <p className="text-xs text-zinc-500 uppercase tracking-wider mb-1">{label}</p>
                <a href={href} target={href?.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" className="text-white hover:text-[#A3FF00] inline-flex items-center gap-2 font-mono text-sm">
                  <Icon className="w-4 h-4 text-[#A3FF00]" />
                  {value}
                </a>
              </li>
            ))}
          </ul>

          <div className="mt-8 bg-[#0a0a0a] border border-zinc-800 rounded-2xl p-6 text-sm text-zinc-400">
            <p className="text-white font-bold mb-2">FutureXV (Pty) Ltd</p>
            <p>Company registration: <span className="font-mono text-zinc-300">2026/142477/07</span></p>
            <p>Founder &amp; CEO: <span className="text-zinc-300">Lazola Ndyamara</span></p>
          </div>
        </div>
      </div>
    </PublicPageShell>
  );
}
